// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"46c4e1f1","634":"813a14e3","732":"23335250","977":"12626bd8"}[chunkId] + ".chunk.js";
};